import { BadgeCheck } from "lucide-react";

// Blue verified checkmark — shown next to a player-account name when they have BOTH
// a verified email AND a working Facebook link. Use anywhere a registered name renders.
export default function VerifiedBadge({ verified, size = 16, className = "", testid }) {
  if (!verified) return null;
  return (
    <span className={`inline-flex items-center ${className}`} title="Verified — email confirmed & Facebook linked"
      data-testid={testid || "verified-badge"}>
      <BadgeCheck style={{ width: size, height: size, color: "#3b82f6", fill: "rgba(59,130,246,0.18)" }} />
    </span>
  );
}
